<template>
  <span class="set_link" v-if="href == ''"></span>
  <div class="set_link" v-else-if="editData.linkType == 'inside_link'" @click.stop="inside_jump"></div>
  <div class="set_link" v-else @click.stop="outside_jump"></div>
</template>
<script>
export default {
  name: "site_link_index",
  data() {
    return {
      href: "",
      target: ""
    };
  },
  props: {
    editData: {
      type: Object,
      default: null
    }
  },
  watch: {
    editData: {
      handler: function(val) {
        this.formatData(val);
      },
      deep: true
    }
  },
  methods: {
    formatData(data) {
      let type = data.inside_link.type;
      this.target = data.isOpen.length == 0 ? "_self" : "_blank";
      let obj = data.inside_link[type];
      if (data.linkType == "inside_link") {
        if (obj&&obj.value&&obj.value.id) {
          this.href = obj.value.routerPath;
        }
      } else if (data.linkType == "outside_link") {
        let value = data.outside_link.url.replace(/^\s+|\s+$/g, "");
        if (value !== "") {
          this.href = data.outside_link.url;
        }
      }
    },
    //站内跳转
    inside_jump() {
      this.templet.clickTime(() => {
        if (this.target == "_self") {
          this.templet.is_jump(() => {
            this.$router.push({
              path:this.href
            });
          });
        } else {
          const { href } = this.$router.resolve({
            path: this.href
          });
          window.open(href, "_blank");
        }
      });
    },

    //站外跳转
    outside_jump() {
      this.templet.clickTime(() => {
        if (this.target == "_self") {
          location.href = this.href;
        } else {
          const new_window = window.open();
          new_window.location.href = this.href;
        }
      });
    }
  },
  components: {},
  mounted() {
    this.formatData(this.editData);
  }
};
</script>

<style scoped lang="scss">
.set_link {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/set_link/components/site_link.vue